import React from "react";
import "./index.less";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { useCurrency } from "@/hooks/useCurrency";
import { getCurrentSiteName } from "@/utils/countryConfigUtils";

const Help = () => {
  const { t } = useTranslationPlus();
  const currency = useCurrency();
  const siteName = getCurrentSiteName();

  return (
    <div className="dialog-wheel-help">
      <div
        dangerouslySetInnerHTML={{
          __html: t("shareFriendWheel.text-7", { currency, siteName }),
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: t("shareFriendWheel.text-8", {
            host: window.location.host,
            currency,
          }),
        }}
      ></div>
    </div>
  );
};

export default Help;
